
const myClass = class ordenTrabajo{
	constructor($scope, $rootScope){
		this.scope             = $scope;
		this.rootScope         = $rootScope;
		this.scope.nombre      = 'Ordenes de trabajo';
		this.scope.sortType    = 'default';
		this.scope.sortReverse = '';
		this.scope.searchFish  = '';
		this.scope.ott         = this.rootScope.ott || [];
		// $scope.ott = [
		// 	{
		// 		id: '4',
		// 		nombre: 'asd',
		// 		codigo: 'ujb',
		// 		correlativo: '',
		// 		fecha_creacion: '14/5/2015',
		// 		fecha_inicio: '15/5/2015',
		// 		observaciones: '-',
		// 		periodo_gestion: '4d',
		// 		custom: '',
		// 		usuario: 'ram123',
		// 		severidad: 'preocupante',
		// 		tarea: 'cortar'
		// 	},
		// 	{
		// 		id: '5',
		// 		nombre: 'bsd',
		// 		codigo: 'ujb',
		// 		correlativo: '',
		// 		fecha_creacion: '14/5/2015',
		// 		fecha_inicio: '15/5/2015',
		// 		observaciones: '-',
		// 		periodo_gestion: '4d',
		// 		custom: '',
		// 		usuario: 'ram123',
		// 		severidad: 'preocupante',
		// 		tarea: 'cortar'
		// 	},
		// 	{
		// 		id: '6',
		// 		nombre: 'csd',
		// 		codigo: 'ujb',
		// 		correlativo: '',
		// 		fecha_creacion: '14/5/2015',
		// 		fecha_inicio: '15/5/2015',
		// 		observaciones: '-',
		// 		periodo_gestion: '4d',
		// 		custom: '',
		// 		usuario: 'ram123',
		// 		severidad: 'preocupante',
		// 		tarea: 'cortar'
		// 	},
		// 	{
		// 		id: '6',
		// 		nombre: 'csd',
		// 		codigo: 'ujb',
		// 		correlativo: '',
		// 		fecha_creacion: '14/5/2015',
		// 		fecha_inicio: '15/5/2015',
		// 		observaciones: '-',
		// 		periodo_gestion: '4d',
		// 		custom: '',
		// 		usuario: 'ram123',
		// 		severidad: 'preocupante',
		// 		tarea: 'cortar'
		// 	},
		// 	{
		// 		id: '6',
		// 		nombre: 'csd',
		// 		codigo: 'ujb',
		// 		correlativo: '',
		// 		fecha_creacion: '14/5/2015',
		// 		fecha_inicio: '15/5/2015',
		// 		observaciones: '-',
		// 		periodo_gestion: '4d',
		// 		custom: '',
		// 		usuario: 'ram123',
		// 		severidad: 'preocupante',
		// 		tarea: 'cortar'
		// 	},
		// 	{
		// 		id: '6',
		// 		nombre: 'csd',
		// 		codigo: 'ujb',
		// 		correlativo: '',
		// 		fecha_creacion: '14/5/2015',
		// 		fecha_inicio: '15/5/2015',
		// 		observaciones: '-',
		// 		periodo_gestion: '4d',
		// 		custom: '',
		// 		usuario: 'ram123',
		// 		severidad: 'preocupante',
		// 		tarea: 'cortar'
		// 	},
		// 	{
		// 		id: '6',
		// 		nombre: 'csd',
		// 		codigo: 'ujb',
		// 		correlativo: '',
		// 		fecha_creacion: '14/5/2015',
		// 		fecha_inicio: '15/5/2015',
		// 		observaciones: '-',
		// 		periodo_gestion: '4d',
		// 		custom: '',
		// 		usuario: 'ram123',
		// 		severidad: 'preocupante',
		// 		tarea: 'cortar'
		// 	}
		// ];
		console.log($scope.nombre);
	}
}

export default myClass;



// WEBPACK FOOTER //
// ./app/js/controllers/ordenesTrabajo/ordenesTrabajo.js